import { lazy } from 'react'

import type { RouteObject } from 'react-router'

const ConfiguracoesPerfilChilePage = lazy(() =>
  import('@/features/configuracoes/chile/pages/perfil').then((module) => ({
    default: module.ConfiguracoesPerfilChilePage,
  })),
)

const ConfiguracoesTermosChilePage = lazy(() =>
  import('@/features/configuracoes/chile/pages/termos').then((module) => ({
    default: module.ConfiguracoesTermosChilePage,
  })),
)

const ConfiguracoesParametrosChilePage = lazy(() =>
  import('@/features/configuracoes/chile/pages/parametros').then((module) => ({
    default: module.ConfiguracoesParametrosChilePage,
  })),
)

const ConfiguracoesSimulacoesChilePage = lazy(() =>
  import('@/features/configuracoes/chile/pages/simulacoes').then((module) => ({
    default: module.ConfiguracoesSimulacoesChilePage,
  })),
)

export const chileConfiguracoesRoutes: RouteObject[] = [
  {
    path: 'es-CL/configuracoes',
    children: [
      {
        path: 'perfil',
        element: <ConfiguracoesPerfilChilePage />,
      },
      {
        path: 'termos',
        element: <ConfiguracoesTermosChilePage />,
      },
      {
        path: 'parametros',
        element: <ConfiguracoesParametrosChilePage />,
      },
      {
        path: 'simulacoes',
        element: <ConfiguracoesSimulacoesChilePage />,
      },
    ],
  },
]
